import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDemandProductList = createAsyncThunk("fetchDemandProductList", async ({ page, limit, periodId, customerId, keyword, status }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: keyword ?? "",
		customerId: customerId ?? "",
		periodId: periodId ?? "",
		status: status ?? "",
	});

	const response = await axiosHttp.get(`/demand/list/product?${params}`, config);
	return response.data.data;
});

const DemandProductListSlice = createSlice({
	name: "DemandProductListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDemandProductList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDemandProductList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchDemandProductList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DemandProductListSlice.reducer;
